import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import React from "react";
import {
  Backdrop,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import { useOutletContext } from "react-router-dom";
import GetVendorsList from "hooks/vendorsList/GetVendorsList";
import SearchInput from "components/searchInput";
import DataTable from "comps/Tables/DataTable";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";

function VendorsList() {
  const navigate = useNavigate();
  const {
    vendors,
    totalLength,
    setPage,
    page,
    setSearch,
    search,
    isLoading,
    setEntriesPerPage,
    entriesPerPage,
    filter,
    setFilter,
  } = GetVendorsList();
  const { setIsEdit, setVendor } = useOutletContext();
  let { primary } = colors;
  let rows = vendors || [];

  let columns = [
    {
      accessor: "id",
      Header: "Vendor Id",
      align: "left",
      Cell: ({ row }) => {
        return <div style={{ width: "80px" }}>{row.original.id}</div>;
      },
    },

    {
      accessor: "vendor_name",
      Header: "Vendor Name",
      sortable: true,
      align: "left",
      headerAlign: "center",
      Cell: ({ row }) => {
        const name = row?.original?.vendor_name || "";
        const truncatedName = name.length > 15 ? name.substring(0, 15) + "..." : name;
        return (
          <Tooltip title={name}>
            <div>{truncatedName}</div>
          </Tooltip>
        );
      },
    },

    {
      accessor: "contact_email",
      Header: "Email",
      sortable: true,
      align: "left",
      Cell: ({ row }) => {
        return (
          <div>{row.original.contact_email}</div>
        );
      },
    },
    {
      accessor: "vendor_type",
      Header: "Vendor Type",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return <div>{row.original.vendor_type}</div>;
      },
    },
    {
      accessor: "vendor_tier",
      Header: "Vendor Tyre",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return <div>{row.original.vendor_tier}</div>;
      },
    },
    {
      accessor: "expose_surveys",
      Header: "Expose Survey",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return (
          <div>{row.original.expose_surveys ? "true" : "false "}</div>
        );
      },
    },
    {
      accessor: "vCPI_range",
      Header: "VCPI Range",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return <div>{row.original.vCPI_range}</div>;
      },
    },
    {
      accessor: "LOI_range",
      Header: "LOI Range",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return <div>{row.original.LOI_range}</div>;
      },
    },
    {
      accessor: "IR_range",
      Header: "IR Range",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return <div>{row.original.IR_range}</div>;
      },
    },
    {
      accessor: "conversion_range",
      Header: "Conv. Range",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return (
          <div>{row.original.conversion_range}</div>
        );
      },
    },
    {
      accessor: "ePC_range",
      Header: "ePC Range",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return <div>{row.original.ePC_range}</div>;
      },
    },
    {
      accessor: "client_starts_value",
      Header: "Client Starts Value",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return (
          <div style={{ width: "150px" }}>
            {row.original.client_starts_value}
          </div>
        );
      },
    },
    {
      accessor: "vendor_status",
      Header: "Vendor Status",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return (
          <div>{row.original.vendor_status ? "true" : "false "}</div>
        );
      },
    },
    {
      accessor: "vendor_is_active",
      Header: "Is Active",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return (
          <div>{row.original.vendor_is_active ? "true" : "false "}</div>
        );
      },
    },
    {
      accessor: "vendor_guid",
      Header: "Vendor Guid",
      align: "left",
    },
  ];

  return (
    <>
      {isLoading && <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>}
      <MDBox pb={0} width="100%" px={1} mt={0}>
        <Grid container spacing={1} pb={1} mb={1}
          sx={{
            // flexDirection: { xs: "column", md: "row" },
            // alignItems: { xs: "flex-end", md: "center" },
            borderBottom: `2px solid ${primary.main}`,
          }}
        >
          <Grid
            px={0}
            item
            xs={2}
            md={2}
            display="flex"
            alignItems={"center"}
            flexDirection="row"
            sx={{
              // flexDirection: { xs: "column", md: "row" },
              // alignItems: { xs: "flex-end", md: "center" },
            }}
            gap="15px"
          >
            <MDTypography fontSize="22px" color="black" >
              Vendors
            </MDTypography>
          </Grid>
          <Grid
            px={1}
            item
            xs={10}
            md={10}
            display="flex"
            justifyContent="flex-end"
            flexDirection="row"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-end", md: "center" },
            }}
            gap="15px"
          >
            <MDButton
              variant="contained"
              color="info"
              onClick={() => {
                navigate("/vendors/new");
                setVendor({});
                setIsEdit({
                  disabled: false,
                  edit: false,
                });
              }}
            >
              + New Vendor
            </MDButton>
          </Grid>
        </Grid>
        <MDBox display="flex" justifyContent="center">
          <MDBox py={2} mt={1} borderRadius="5px" bgColor="white" width="100%">
            <Grid container spacing={2} pb={1} px={2}>
              <Grid
                px={0}
                item
                xs={12}
                md={12}
                display="flex"
                justifyContent="flex-end"
                flexDirection="row"
                sx={{
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "flex-end", md: "center" },
                }}
                gap="15px"
              >
                <FormControl sx={{ width: "200px" }}>
                  <InputLabel>Filter</InputLabel>
                  <Select
                    size="small"
                    value={filter}
                    label="Filter"
                    onChange={(e) => {
                      setFilter(e.target.value);
                    }}
                  >
                    <MenuItem value={-1}>All</MenuItem>
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={2}>Inactive</MenuItem>
                  </Select>
                </FormControl>
                <SearchInput setSearch={setSearch} search={search} />
                {/* <MDButton
                  variant="contained"
                  color="info"
                  onClick={() => {
                    navigate("/vendors/new");
                    setVendor({});
                    setIsEdit({
                      disabled: false,
                      edit: false,
                    });
                  }}
                >
                  + New Vendor
                </MDButton> */}
              </Grid>
            </Grid>
            <DataTable
              table={{ columns, rows }}
              isSorted
              noEndBorder
              entriesPerPage={entriesPerPage}
              canSearch={false}
              tablePage={page}
              setTablePage={setPage}
              navigateRow={"/vendors"}
              setEntriesPerPage={setEntriesPerPage}
              totalLength={totalLength}
              pagination={true}
              tableMaxHeight={"calc(100vh - 280px)"}
              tableMinHeight={"calc(100vh - 280px)"}
            />
          </MDBox>
        </MDBox>
      </MDBox>
    </>
  );
}

export default VendorsList;
